import { render } from "./HomeUseful.vue?vue&type=template&id=4a82a34e"
import script from "./HomeUseful.vue?vue&type=script&lang=js"
export * from "./HomeUseful.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__